import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";
import {UserService } from "../user/user.service";
import {Instructor} from "../../models/instructor.model";

export interface InstructorServicePromise {
    getAll: (grade: number) => angular.IPromise<Instructor[]>;
}

export interface InstructorResponse {
    data: Instructor[];
}
export interface InstructorsService { (tenantId: string): angular.IPromise<Instructor[]>; }

/* @ngInject */
export function instructorsService(userService: UserService, API_URL: ApiUrl, $http: angular.IHttpService, $q: angular.IQService) {
    let makeInstructorDisplayName = (instructor): void => {
        let name = instructor.name;
        let middle = name.middleName ? `${name.middleName} ` : "";
        instructor.name.displayName = `${name.firstName} ${middle}${name.lastName}`;
    };

    return (tenantId: string): angular.IPromise<Instructor[]> => {
        return $http.get(`${API_URL.instructors}?query={"tenantId": "${tenantId}"}`).then((response: InstructorResponse) => {
            response.data.forEach(makeInstructorDisplayName);
            return response.data;
        }, (errorResponse) => {
            if (errorResponse && errorResponse.status === 404) {
                return [];
            } else {
                return $q.reject(errorResponse);
            }
        });
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/instructors/instructors.service.ts
 **/